import { exchange } from "@ls/js-fetch";
import { useQuery } from "react-query";

export const useGroupingLevelKeysQuery = (level, date) => {
  return useQuery({
    queryKey: ["groupingLevelKeys", level, date],
    enabled: !!level && !!date,
    queryFn: async () => {
      if (!level || !date) {
        return [];
      }
      const url = new URL(
        "group/keys",
        process.env.REACT_APP_BASE_URL_GROUPING_SERVICE
      );
      url.searchParams.set("appName", process.env.REACT_APP_ID);
      url.searchParams.set("levels", level);
      url.searchParams.set("date", date);
      url.searchParams.set("group_type", "entity_list");
      url.searchParams.set("ids", "559730"); //559730, all securities

      const data = (
        await exchange({
          url: url.toString(),
        })
      )?.data;
      return data?.[level];
    },
  });
};
